module.exports = __webpack_public_path__ + "assets/img/38_444.ad772825.jpg";